<template>
    <div>
        <b-alert
            variant="secondary"
            show
        >
            <h1>{{ config.title }}</h1>
            <button
                v-if="config.downloadable"
                class="sc-btn pill"
                @click="download()"
            >
                <font-awesome-icon icon="download" class="mr-2" />
                Download
            </button>
        </b-alert>
        <iframe
            v-if="config.viewable"
            :src="pdfUrl"
        ></iframe>
    </div>
</template>
<script>
import { base_url } from "@/api/getBaseUrl"
import { downloadFile } from "@/api/downloadFile"
import { mapState } from 'vuex'

const view_pdf_config = {
    descriptions: {
        title: 'All Class Descriptions',
        downloadable: true,
        viewable: true,
        resource_path: '/class-descriptions/all-descriptions.pdf'
    }
};

export default {
    props: ["pdf_name"],
    computed: {
        config() {
            return view_pdf_config[this.pdf_name] || { viewable: false, title: 'No pdf with this name was found.' };
        },
        pdfUrl() {
            return `${base_url}/api/pdf${this.config.resource_path}?semester_id=${this.semester.id}&token=${this.token}`;
        },
        ...mapState(["token", "semester"])
    },
    methods: {
        download() {
            downloadFile(
                this.pdfUrl,
                this.config.resource_path.split("/").pop() || "file.pdf"
            );
        }
    }
}
</script>
<style scoped>
iframe {
    width: 100%;
    height: 100vh;
    border: none;
}
</style>